import React, {Fragment, useEffect, useState} from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Card, Row, Col, Button, Form, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Auth, LoadingComponent} from 'recupero-comunes'
import BuscarHonorarios from './buscar-honorarios'
import BandejaHonorarios from './bandeja-honorarios'
import { configuracionFormAction97, obtenerCompanias, obtenerOrigenes, obtenerSituaciones } from '../../store/actions/solicitud-honorarios-action'
import { obtenerDatosLlaves } from '../../store/actions/gestion-defensa-action'
import { formatoMonto } from '../../common/Formatos'
import { serviceGestionHonorarios } from '../../api/api-solicitud-honorarios'
import Mensajes from '../mensajes.js'
import { obtenerConsultaHonorarios } from '../../store/actions/solicitud-honorarios-action'

const AreaBusquedaSolicitudHonorarios = () => {
    
    const [loading, setLoading]=useState(false)
    const { rutUsuario, rutOrganizacion } = Auth.currentUser()
    const [myQueryState, setMyQuery]=useState(null)
    const data_encargado = useSelector((state) => state.gestionDefensaReducer)
    const {llaves} = data_encargado
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso :30
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880
    
    const dispatch = useDispatch()
    
    const data_solitudHonorarios = useSelector((state) => state.solicitudHonorariosReducer)
    const {cfg_form97, consultaHonorarios} = data_solitudHonorarios

    const [selectedRows, setSelectedRows] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true) 
    const [respuestaGestion, setRespuestaGestion] = useState({});

    const handleCloseToast = () => {
        setShowToast(false);
        setSelectedRows([]);   
        setShowModal(false);      
        handleReload();         
    }

    const [modalSolicitarData, setModalSolicitarData] = useState({
        mandante: '',
        origenHo: '',
        cantidadHo: 0,
        totalAFacturar: 0,
        fecha: '',
    });

    useEffect(()=>{
        
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado, idOrgCaso:idOrganizacionCaso}))

    },[dispatch])

    useEffect(() => {
        if(llaves){ 
        setLoading(true)
         let query = Buffer.from(JSON.stringify({
             rutcia: llaves && llaves['idOrgCaso'],
             idform: 97
         })).toString('base64')
         dispatch(configuracionFormAction97(query))
         .then(()=>{
            let query = Buffer.from(JSON.stringify({})).toString('base64')
            dispatch(obtenerCompanias(query))
        })
        .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 304 })
              ).toString('base64')
              dispatch(obtenerOrigenes(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 305 })
              ).toString('base64')
              dispatch(obtenerSituaciones(query))
         })
         .then(()=>setLoading(false))
        }
     }, [dispatch,llaves])

    const handleSolicitarHono = () => {
        if (selectedRows.length === 0) {
            alert("Debe seleccionar al menos un honorario");
            return;
        }
        const cantidadHo = selectedRows.length;
        const totalAFacturar = selectedRows.reduce((sum, row) => sum + Number(row.montoNetoFacturado), 0);

        // Tomamos datos generales de la primera fila, por ejemplo Mandante y Origen Ho
        const { mandante, glosaOrigen, fecha } = selectedRows[0];

        setModalSolicitarData({
            mandante,
            glosaOrigen,
            cantidadHo,
            totalAFacturar,
            fecha,
        });

        setShowModal(true);
    }
    
    const handleConfirmar = async () => {
        let data = {
            honorarios : selectedRows,
            accion: 1//Ingreso solicitud Grupo HO
        }

        setLoading(true);
        const response = await serviceGestionHonorarios(data);
        setLoading(false);

        setRespuestaGestion(response);
        handleShowToast(true);        
    }
    const handleCloseModalSolicitaHo = () => {
        setShowModal(false)
    }
    const handleReload = () => {
        if (consultaHonorarios && consultaHonorarios.query) {
            setLoading(true);
            let query = consultaHonorarios.query;
            dispatch(obtenerConsultaHonorarios(query)).then(() => {
                setLoading(false);
            });
        }
    }
    return (
        <>
        <style type='text/css'>
            {`
                .btn-confirmar{
                  background-color: #C14B49;
                  color: #FFFFFF;
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-confirmar:hover{
                  background-color: #F6897E;
                  color: #FFFFFF;
                }
                .btn-cancelar {
                  background-color: #00aeab;
                  color: #FFFFFF;  
                  width: 140px;
                  padding:6px 0px 6px 0px;
                }
                .btn-cancelar:hover{
                  background-color: #87c9dc;
                  color: #FFFFFF;
                }         
            `}
        </style>
        <div> 
            <LoadingComponent show={loading}/>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h5'>{cfg_form97 && `${cfg_form97.cfg_form97['busqueda-solicitud-honorarios-title']}`}</Card.Header>
                    <Card.Body>
                        <BuscarHonorarios 
                            setMyQuery={setMyQuery} 
                            handleSolicitarHono={handleSolicitarHono}
                            setSelectedRows={setSelectedRows}
                        />
                        <BandejaHonorarios 
                            myQueryState={myQueryState} 
                            selectedRows={selectedRows}
                            setSelectedRows ={setSelectedRows}
                        />                  
                    </Card.Body>
                </Card>
            </Container>
            
            <Modal show={showModal} onHide={handleCloseModalSolicitaHo} backdrop='static' size='lg'>
                <Modal.Header closeButton style={{background:'rgb(226, 227, 229)'}}>
                    <Modal.Title>Confirmar Solicitud de Honorarios</Modal.Title>          
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-4">
                        <Row>
                            <Col><strong>Mandante:</strong> <div>{modalSolicitarData.mandante}</div></Col>
                            <Col><strong>Origen Honorarios:</strong> <div>{modalSolicitarData.glosaOrigen}</div></Col>
                            <Col><strong>Cantidad Honorarios:</strong> <div>{modalSolicitarData.cantidadHo}</div></Col>
                            <Col><strong>Total a Facturar:</strong> <div>{formatoMonto(modalSolicitarData.totalAFacturar)}</div></Col>
                            <Col><strong>Fecha Solicitud:</strong> <div>{modalSolicitarData.fecha}</div></Col>
                        </Row>
                    </Form.Group>
                </Modal.Body>
                <Container>
                    <Row>
                        <Col>
                            {respuestaGestion && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={respuestaGestion}
                                ></Mensajes>
                            }
                        </Col>
                    </Row>
                </Container> 
                <Modal.Footer> 
                    <Button className='me-md-2' variant='cancelar' type='button' onClick={handleCloseModalSolicitaHo}>Cancelar</Button>
                    <Button variant='confirmar' type='button' onClick={handleConfirmar}>Confirmar</Button>         
                </Modal.Footer>
            </Modal>
        </div>
        </>
    )
}
export default AreaBusquedaSolicitudHonorarios
